// extracted by mini-css-extract-plugin
export default {"badge":"badge--17kbv"};
    if(module.hot) {
      // 1747648146617
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  